import { isObject } from 'lodash';

export default function findByIndexOrProperty(items, indexOrValue, property = null) {
    if (indexOrValue === undefined || indexOrValue === '') {
        return undefined;
    }
    if (typeof indexOrValue === 'number') {
        return items[indexOrValue];
    }
    if (property) {
        if (typeof indexOrValue === 'string') {
            const value = indexOrValue.toLowerCase();
            return items.find((item) => item[property]?.toLowerCase() === value);
        }
        if (isObject(indexOrValue) && indexOrValue[property]) {
            return items.find((item) => item[property] === indexOrValue[property]);
        }
    } else if (isObject(indexOrValue)) {
        return items.find((item) => item === indexOrValue);
    }

    return undefined;
}
